export default "__VITE_ASSET__B8LhGYG0__"